import { z } from 'zod';
import { getParticipantsWithPastShiftsTableFilterDataSchema, participantWithPastShiftsRowSchema, } from './participantsWithPastShiftsCommonSchema';
const getParticipantsWithPastShiftsParamsSchema = z.object({
    filterData: getParticipantsWithPastShiftsTableFilterDataSchema,
    limit: z.number().optional(),
    offset: z.number().optional(),
});
const getParticipantsWithPastShiftsResponseSchema = z.object({
    rows: participantWithPastShiftsRowSchema.array(),
    total: z.number(),
    analytics: z.object({
        totalPendingHours: z.number(),
    }),
});
export const getParticipantsWithPastShiftsFunctionDef = {
    name: 'getParticipantsWithPastShifts',
    requestSchema: getParticipantsWithPastShiftsParamsSchema,
    responseSchema: getParticipantsWithPastShiftsResponseSchema,
};
